import { __decorate } from "tslib";
import { ArrayDecoder, AutoEncoder, BooleanDecoder, field, StringDecoder } from "@simonbackx/simple-encoding";
import { v4 as uuidv4 } from "uuid";
import { Language } from "./Language";
export class UserPermissions extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.isAdmin = false;
        this.isTester = false;
        this.wholesalerIds = [];
    }
}
__decorate([
    field({ decoder: BooleanDecoder })
], UserPermissions.prototype, "isAdmin", void 0);
__decorate([
    field({ decoder: BooleanDecoder, version: 22 })
], UserPermissions.prototype, "isTester", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(StringDecoder) })
], UserPermissions.prototype, "wholesalerIds", void 0);
export class User extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.defaultCustomerId = null;
        this.emailCanBeShared = false;
        this.language = Language.nl;
    }
}
__decorate([
    field({ decoder: StringDecoder, defaultValue: () => uuidv4() })
], User.prototype, "id", void 0);
__decorate([
    field({ decoder: StringDecoder })
], User.prototype, "email", void 0);
__decorate([
    field({ decoder: UserPermissions, nullable: true })
], User.prototype, "permissions", void 0);
__decorate([
    field({ decoder: StringDecoder, optional: true, nullable: true })
], User.prototype, "defaultCustomerId", void 0);
__decorate([
    field({ decoder: BooleanDecoder, optional: true })
], User.prototype, "emailCanBeShared", void 0);
__decorate([
    field({ decoder: StringDecoder, optional: true, version: 25 })
], User.prototype, "language", void 0);
export class UserPrivate extends User {
}
__decorate([
    field({ decoder: StringDecoder, optional: true })
], UserPrivate.prototype, "setPassword", void 0);
//# sourceMappingURL=User.js.map